var map = {
	"./camcore/logo.png": 7271,
	"./camcore/vegankilling/background.png": 1791,
	"./camcore/vegankilling/camcore.png": 9799,
	"./camcore/vegankilling/dropkick.png": 8477,
	"./cancelcancer/ambassadors/Amy Mußul.png": 5434,
	"./cancelcancer/ambassadors/Joris.png": 8223,
	"./cancelcancer/ambassadors/Sven Martinek.png": 216,
	"./cancelcancer/ambassadors/tkreideweis.png": 6872,
	"./cancelcancer/ambassadors/twentzel.png": 9632,
	"./cancelcancer/ambassadors/vmohnke.png": 9778,
	"./cancelcancer/images/1.png": 7954,
	"./cancelcancer/images/10.png": 9502,
	"./cancelcancer/images/2.png": 7442,
	"./cancelcancer/images/3.png": 33,
	"./cancelcancer/images/4.png": 7959,
	"./cancelcancer/images/5.png": 9843,
	"./cancelcancer/images/6.png": 9940,
	"./cancelcancer/images/7.png": 8249,
	"./cancelcancer/images/8.png": 1704,
	"./cancelcancer/images/9.png": 6808,
	"./cancelcancer/images/Die Erfolgsgeschichte von Leo.png": 8405,
	"./cancelcancer/images/Die Stimme der Experten.png": 6653,
	"./cancelcancer/images/Initiatoren.png": 4679,
	"./cancelcancer/images/Milas Briefe.png": 9752,
	"./cancelcancer/images/Shirtaktion.png": 1853,
	"./cancelcancer/images/UFA x Cancel Cancer.png": 6824,
	"./cancelcancer/images/berlinale2025.png": 6821,
	"./cancelcancer/images/rlt.png": 971,
	"./cancelcancer/images/sepa.png": 7354,
	"./cancelcancer/partners/UFA.png": 5825,
	"./cancelcancer/references/1.png": 7330,
	"./cancelcancer/references/2.png": 7569,
	"./cancelcancer/references/3.png": 8045,
	"./cancelcancer/references/4.png": 72,
	"./cancelcancer/references/5.png": 1266,
	"./cancelcancer/supporter.png": 2232,
	"./cancelcancer/supporterm.png": 582,
	"./images/awards/cannes.png": 7656,
	"./images/awards/deutscherkamerapreis.png": 4293,
	"./images/awards/jupiter.png": 6421,
	"./images/awards/lafa.png": 5818,
	"./images/awards/selb.png": 1552,
	"./images/awards/shokingshorts.png": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;